<template>
  <el-dialog :visible.sync="form_state" title="Массовая смена оператора" :append-to-body="true" width="450px">
    <div v-loading="form.busy">
      <div class="form-row">
        <div class="form-group col-12 row mb-1">
          <label for="id" class="col-4 col-form-label">Оператор</label>
          <div class="col-8">
            <multiselect id="operator" v-model="operator_temp" tag-placeholder="" placeholder="" :options="operators_select" :close-on-select="true"  label="title" track-by="id" :multiple="false" :taggable="false" :selectedLabel="''" :placeholder="''" :selectLabel="''" :deselectLabel="''" :tagPlaceholder="''" :showNoOptions="false"  :searchable="true"  group-values="users" group-label="group_name" :group-select="true" selectGroupLabel="Выбрать всю группу" deselectGroupLabel="Отменить всю группу"></multiselect>
            <has-error :form="form" field="operator_id"/>
          </div>
        </div>
        <div class="form-group col-12">
          <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='Нет'
              title="Уверены что хотите сменить оператора?"
              @confirm="update"
          >
            <button slot="reference" type="button" class="btn btn-primary" :class="{'btn-loading': form.busy, }">Обновить ({{ ids.length }})</button>
          </el-popconfirm>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Form from "vform";
import toastr from "toastr";
import RequestStatusData from "../../../plugins/request_status_data";
import RoleData from "../../../plugins/role_data";
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../../helpers/platform";

export default {
  name: "ChangeOperator",
  components: {Multiselect},
  data: () => ({
    ids: [],
    platform_ids: [],

    operator_temp: null,

    form_state: false,
    form: new Form(),
  }),
  mounted() {
    let self = this;
    this.$bus.$on('changeOperatorBulk:open-form', params => {
      self.ids = params.ids;
      self.platform_ids = params.platform_ids;
      self.form_state = true;
    });
  },
  beforeDestroy() {
    this.$bus.$off('changeOperatorBulk:open-form');
  },
  computed: {
    operators_select () {
      let self = this;
      let data = {};
      if (this.platform_ids.length) {
        this.$store.getters['operators/call_center'].forEach(function (item) {
          if (!item.is_active) return;
          let user_platforms = item.allowed_platforms.map(p => p.id);
          item.allowed_platforms.forEach(function (platform) {
            if (!self.platform_ids.includes(platform.id)) return;
            if (!data[platform.id]) data[platform.id] = {group_name: PlatformHelper.get(platform.id).name, users: []}
            data[platform.id].users.push({
              id: item.id,
              title: item.name,
            });
          })
        });
      }

      data = _.mapValues(data, function (item) {
        item.users = _.sortBy(item.users, ['title'])
        return item;
      });
      return _.values(data);
    },
  },
  watch: {
    form_state(val) {
      this.resetData();
    }
  },
  methods: {
    async update() {
      let self = this;
      if (this.validate()) {
        this.form.operator_id = this.operator_temp ? this.operator_temp.id : null;
        this.form.ids = this.ids;

        this.form.post('/api/requests/changeOperatorBulk')
            .then(r => {
              self.$message.success({
                message: 'Успешно обновлено',
                duration: 2000,
              });
              self.resetData();
              self.form_state = false;
            });
      }
    },
    resetData() {
      this.operator_temp = null;
      this.form = new Form();
    },
    validate: function () {
      this.form = new Form();
      return true;
    },
  }
}
</script>

<style scoped>

</style>
